import React from "react";
import CategoryTemplate from "@components/category/categoryTemplate";
import Compare from "@components/shared/compare";
import { GetStaticPropsContext } from "next";
import {
    getCategoriesDescription,
    getCategoriesKeyWords,
    resolveURL,
    stripHtmlTags,
    titleDecoder,
} from "@lib/sharedUtils";
import { GQLCategories, GQLDomains, GQLUrls } from "@gql/types/gql";
import MetaTags from "@components/shared/metaTags";
import { useQuery } from "@tanstack/react-query";
import initialCall, { initialCallPaths } from "@helpers/initial-call";
import { translate } from "@helpers/translationObjectFormatter";
import {
    ICompareCategoryProps,
    ICustomDomain,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { Session } from "src/api/session";

const Pg = ({ title }: { title: string }) => {
    const { data: props } = useQuery<ICompareCategoryProps, Error>([
        "compareCategoryProps",
    ]);
    const { category } = props ?? {};
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const session = useQuery<Session>({ queryKey: ["session"] });

    const getTitle = () => {
        const titleFromTextBlock = category?.textBlocks?.find(
            (block) => block?.position === "several-category-compare-title",
        )?.text;

        if (titleFromTextBlock) {
            const titleAfterStripping =
                stripHtmlTags(titleFromTextBlock).trim();

            return titleDecoder(titleAfterStripping, {
                category: category?.label ?? category?.name ?? "",
                region: session?.data?.visitDetails?.region ?? "",
            });
        }

        const fallBackTitle = translate(
            translations,
            "several_category_compare_page_title",
            { category: category?.label as string },
        );

        return fallBackTitle;
    };

    return (
        <>
            <MetaTags
                title={`${
                    title
                        ? `${translate(
                              translations,
                              "several_general_compareButton",
                          )} ${title} ${translate(
                              translations,
                              "several_siteMapPage_Vendors",
                          )}`
                        : (category?.label as string)
                        ? (category?.label as string)
                        : (category?.name as string)
                } | Several.com`}
                image={
                    (category?.mainImage?.fullPath as string) ??
                    "public/images25.png"
                }
                description={
                    getCategoriesDescription(
                        category as GQLCategories,
                        domainInfo?.domain as GQLDomains,
                        translate(
                            translations,
                            "several_general_meta_description",
                        ),
                    ) as string
                }
                keyWords={
                    getCategoriesKeyWords(
                        category as GQLCategories,
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
                url={`${resolveURL(category?.url as GQLUrls)}/compare`}
            />
            <CategoryTemplate>
                <Compare pageTitle={getTitle()} />

                {/* Form can't be added here because of shared state between Form and Compare modal */}
                {/* <div className="my-[8rem]">
                <Form />
            </div> */}
            </CategoryTemplate>
        </>
    );
};

export const getStaticProps = async (context: GetStaticPropsContext) => {
    return await initialCall("CategoryCompare", context);
};
export function getStaticPaths() {
    return initialCallPaths();
}
export default Pg;
